import { AdminSidebar } from "@/components/AdminSidebar";
import { DashboardHeader } from "@/components/DashboardHeader";
import { DashboardFooter } from "@/components/DashboardFooter";
import { DocumentCenter } from "@/components/admin/DocumentCenter";
import { SidebarProvider } from "@/components/ui/sidebar";

const AdminDocuments = () => {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-[#1A1F2C] dark:bg-[#0F1219]">
        <AdminSidebar />
        <div className="flex-1">
          <DashboardHeader />
          <main className="pt-16 min-h-[calc(100vh-64px)]">
            <div className="container mx-auto px-4 py-8">
              <DocumentCenter />
            </div>
          </main>
          <DashboardFooter />
        </div>
      </div>
    </SidebarProvider>
  );
};

export default AdminDocuments;